import * as React from 'react';
import { Box, Display, Heading2, JustifyContent, useTheme } from '@gousto-internal/citrus-react';
import { HiddenSelectRecipeButton } from './SelectRecipeButton';

type HeadingProps = {
  children: string;
};

export function Heading({ children }: HeadingProps) {
  const { theme } = useTheme();
  const heading5Size = theme.tokens.typographyDefaults.h5.size;

  return (
    <Box width="100%" display={Display.Flex} justifyContent={JustifyContent.SpaceBetween} gap={2}>
      <Box>
        <Heading2 size={heading5Size}>{children}</Heading2>
      </Box>
      <HiddenSelectRecipeButton />
    </Box>
  );
}
